(ns motorsaif.web.components
  (:require
   ["react" :as react]
   [clojure.string :as str]
   [goog.functions :refer [debounce]]
   [motorsaif.constants :as constants]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.string :as mstr :refer [format]]
   [motorsaif.time :as time]
   [motorsaif.url :as url]
   [motorsaif.utils :as utils]
   [motorsaif.validation :as validation]
   [motorsaif.vars :refer [inline-env]]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.pwa :as pwa]
   [motorsaif.web.svg :as svg]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]
   [reagent.ratom :as ra]))

(defn verified-badge [owner]
  [:i.fa-duotone.fa-badge-check.verified-badge
   (when (utils/official-account? owner) {:class "official"})])

(defn avatar-bg-style [owner-id]
  (let [n (mod (* owner-id 9) 360)
        n (if (and
               (> n 10)
               (< n 100))
            (+ n 100)
            n)
        l (- 70 (mod (* owner-id) 20))]
    ;; n
    {:id owner-id
     :style
     ;; {:background (format "hsl(%d, 50%, 45%)" n)}
     {:background (format "hsl(%d, %d%, %d%)" n l l)}
     }))

;; (- 70 (mod 300 20))
(comment
  (map avatar-bg-style (range 3)))

(defn avatar-letter [profile {:keys [class notification]}]
  (let [id (:db/id profile)
        handle (utils/owner-handle profile)
        biz? (:business/name profile)
        current-user (:db/id @(subscribe [:user]))
        online-state @(subscribe [:user-online-state id])
        klasses (utils/cond-css
                 biz? "biz"
                 notification "notification"
                 online-state (and online-state
                                   (str "online-state " (name online-state)))
                 class class)
        attr (->
              (avatar-bg-style id)
              (assoc :class klasses))
        official? (utils/official-account? profile)]
    (if official?
      [:div.avatar.letter.official
       attr
       svg/logo]
      [:div.avatar.letter
       attr
       [:span
        (first handle)]])))

(defn ago-str-interval [time ms]
  (let [*dirty (r/atom 0)
        *interval (atom nil)]
    (r/create-class
      {:component-did-mount
       #(reset! *interval (js/setInterval
                           (fn []
                             (swap! *dirty inc)) ms))
       :component-will-unmount #(js/clearInterval @*interval)
       :reagent-render
       (fn []
         ^{:key @*dirty}
         [:span.ago-str (time/tr-ago-str time)])})))

(defn avatar-letter-with-handle [{:keys [owner letter-class posted no-link]}]
  (let [{owner-id :db/id} owner
        handle (utils/owner-handle owner)
        biz? (:business/name owner)]
    (if biz?
      [(if no-link
         :span.biz-profile
         :a.biz-profile)
       (when-not no-link
         {:href (routes/path-for :public-profile {:id owner-id})
          :on-click #(do
                       (.stopPropagation %)
                       (.preventDefault %)
                       (rf/dispatch [:common/navigate! :public-profile {:id owner-id}]))})
       [:div.letter-with-handle-wrap
        [avatar-letter owner {:class letter-class}]
        [:span.wrap.text
         [:span.handle.semi
          [verified-badge owner]
          handle]
         (when posted
           [:span
            [:span.clr-brand-secondary.sep " • "]
            [:span.posted
             [ago-str-interval posted (* 60 1000)]]])]]]
      [:div.letter-with-handle-wrap
       [avatar-letter owner {:class letter-class}]
       [:span.wrap.text
        [:span.handle.semi handle]
        (when posted
          [:span
           [:span.clr-brand-secondary.sep " • "]
           [:span.posted
            [ago-str-interval posted (* 60 1000)]]])]])))

(defn avatar-letter-with-link [{:keys [owner size posted letter-class]}]
  (let [{owner-id :db/id} owner
        handle (utils/owner-handle owner)
        size (name (or size :small))
        biz? (:business/name owner)
        attr (merge {:class size} (avatar-bg-style owner-id))]
    (if biz?
      [:a.biz-profile
       {:href (routes/path-for :public-profile {:id owner-id})
        :on-click #(do
                     (.stopPropagation %)
                     (.preventDefault %)
                     (rf/dispatch [:common/navigate! :public-profile {:id owner-id}]))}
       [:div.letter-with-handle-wrap
        [avatar-letter owner {:classs letter-class}]]]
      [:div.letter-with-handle-wrap
       [avatar-letter owner {:class letter-class}]])))

(defn mobile-photos [{:keys [media]}]
  (let [shown-media (take 5 (sort-by :media/order media))
        ref (react/createRef)
        *img-idx (r/atom 0)

        *scroll-container (atom nil)

        *img-array (atom nil)
        gen-img-array (fn []
                        (reset! *img-array
                                (mapv (fn [i] (* i (+ 10 ; margin-right from CSS
                                                      (.-clientWidth (.-current ref)))))
                                      (range (count shown-media)))))

        ;; _ (def hae ref)
        on-scroll (debounce (fn [sl]
                              (let [img-array (or @*img-array (gen-img-array))]
                                ;; (log/info [:deb sl])
                                (let [slack 30
                                      found-offset (first (filter #(<= (- sl slack) % (+ sl slack)) img-array))]
                                  (when found-offset
                                    (reset! *img-idx (.indexOf img-array found-offset))))))
                            15)]
    (r/create-class
      {:reagent-render
       (fn [{:keys [id]}]
         [:div.mobile-non-expanded-photos
          {:ref ref}
          [:div.wrapper
           (into [:div.images
                  {:ref (fn [c]
                          (when c
                            (reset! *scroll-container c)))
                   :on-scroll #(on-scroll (.-scrollLeft (.-target %)))}
                  ]
                 (map-indexed
                  (fn [idx img]
                    [(fn [img]
                       [:a.wrap
                        {:href ""}
                        [:img
                         {:src (url/uploaded-media {:media img
                                                    :size :med})
                          :on-load
                          (fn [_]
                            (when (= (count shown-media)
                                     (count @*img-array))
                              (set! (.-scrollLeft @*scroll-container) 0)))}]]) img])
                  shown-media))]
          (when (> (count media) 1)
            [(fn [_img-array] ; ?
               (into [:div.dots]
                     (map (fn [idx]
                            [:span.dot
                             {:class (when (= idx @*img-idx) "active")}])
                          (range (count media))))) @*img-array])])})))

(defn header-with-back
  [title & opts]
  (let [{:keys [back-fn subtitle fallback-back-route]} opts
        back-fn #(if back-fn
                   (back-fn)
                   (if (> (.-length js/window.history) 2)
                     (.back js/window.history)
                     (rf/dispatch [:common/navigate! fallback-back-route])))]
    [:div#page-header.with-back
     [:button.btn.ghost
      (-> {:type "button"}
          (cond-> utils/is-ios?
            (assoc :on-touch-end back-fn)
            (not utils/is-ios?)
            (assoc :on-click back-fn)))
      [:i.fa-regular.fa-chevron-left]] [:div.title-wrap
                                        [:h2 title]
                                        (when subtitle
                                          [:div.subtitle subtitle])]]))

(defn header
  [title & opts]
  (let [{:keys [subtitle]} opts
        *current-owner (subscribe [:current-owner])]
    [:div#page-header
     [:div.title-wrap
      [:h2 title]
      (when subtitle
        [:div.subtitle subtitle])]
     (when @*current-owner
       [:button.reset-button
        {:on-click #(rf/dispatch [:set-ui-state :side-menu-open true])}
        [avatar-letter @*current-owner
         {:class "shadow"
          :notification (pwa/can-sub?)}]])]))

(defn get-gps-pos [callback]
  (let [?nav js/navigator.geolocation]
    (when ?nav
      (.getCurrentPosition ?nav
                           (fn [pos]
                             (let [lat ^js (.-coords.latitude pos)
                                   lng ^js (.-coords.longitude pos)]
                               (callback
                                {:lat lat
                                 :lng lng})))))))

(defn g-map [{:keys [opts coords *map *marker on-pos-change]}]
  (let [ref (react/createRef)]
    (r/create-class
      {:component-did-mount
       (fn []
         (let [ele (.-current ref)
               coords (clj->js coords)
               opts #js {:zoom 10
                         :streetViewControl false
                         :center coords}
               map (js/window.google.maps.Map. ele opts)
               marker (js/window.google.maps.Marker. (clj->js {:map map
                                                               :draggable true
                                                               :position coords}))
               geocoder (js/window.google.maps.Geocoder.)]
           (reset! *map map)
           (reset! *marker marker)

           ;; (def ahe @*marker)
           ;; (def coder (js/window.google.maps.Geocoder.)
           ;;   )

           ;; (def ret (.geocode coder (clj->js {:location (.getPosition ahe)})))
           ;; (.then ret (fn [z]
           ;;              (def hze z)
           ;;              ))

           ;; (js->clj hze)
           ;; => {"results"
           ;; [{"address_components"
           ;;   [{"long_name" "5WXX+2J", "short_name" "5WXX+2J", "types" ["plus_code"]} {"long_name" "Al Dhaid", "short_name" "Al Dhaid", "types" ["locality" "political"]} {"long_name" "Sharjah", "short_name" "Sharjah", "types" ["administrative_area_level_1" "political"]} {"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}]

           ;; , "formatted_address" "5WXX+2J Al Dhaid - Sharjah - United Arab Emirates", "geometry" {"bounds" #object[Object ((25.1975, 55.94900000000001), (25.197625, 55.949125))], "location" #object[Object (25.1975069, 55.9490952)], "location_type" "GEOMETRIC_CENTER", "viewport" #object[Object ((25.19621351970849, 55.9477135197085), (25.1989114802915, 55.9504114802915))]}
           ;; , "place_id" "GhIJ_jvsz48yOUARMWWW83v5S0A", "plus_code" {"compound_code" "5WXX+2J Al Dhaid - Sharjah - United Arab Emirates", "global_code" "7HQQ5WXX+2J"}, "types" ["plus_code"]}

           ;;  {"address_components" [{"long_name" "Unnamed Road", "short_name" "Unnamed Road", "types" ["route"]} {"long_name" "Maghsa", "short_name" "Maghsa", "types" ["political" "sublocality" "sublocality_level_1"]} {"long_name" "Al Dhaid", "short_name" "Al Dhaid", "types" ["locality" "political"]} {"long_name" "Sharjah", "short_name" "Sharjah", "types" ["administrative_area_level_1" "political"]} {"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}]
           ;;   , "formatted_address" "Unnamed Road - Maghsa - Sharjah - United Arab Emirates", "geometry" {"bounds" #object[Object ((25.1986083, 55.948152), (25.1998935, 55.95675989999999))], "location" #object[Object (25.1988469, 55.9526852)], "location_type" "GEOMETRIC_CENTER", "viewport" #object[Object ((25.1979019197085, 55.948152), (25.20059988029151, 55.95675989999999))]}, "place_id" "ChIJZ3OMrLCk9T4RskygdIde_Bw", "types" ["route"]}

           ;;  {"address_components" [{"long_name" "Maghsa", "short_name" "Maghsa", "types" ["political" "sublocality" "sublocality_level_1"]} {"long_name" "Al Dhaid", "short_name" "Al Dhaid", "types" ["locality" "political"]} {"long_name" "Sharjah", "short_name" "Sharjah", "types" ["administrative_area_level_1" "political"]} {"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}], "formatted_address" "Maghsa - Al Dhaid - United Arab Emirates", "geometry" {"bounds" #object[Object ((25.1771597, 55.9426758), (25.2176685, 55.9923036))], "location" #object[Object (25.1918469, 55.9626493)], "location_type" "APPROXIMATE", "viewport" #object[Object ((25.1771597, 55.9426758), (25.2176685, 55.9923036))]}, "place_id" "ChIJAczEY8Ok9T4R5quxqqu-Rqg", "types" ["political" "sublocality" "sublocality_level_1"]} {"address_components" [{"long_name" "Al Dhaid", "short_name" "Al Dhaid", "types" ["locality" "political"]} {"long_name" "Sharjah", "short_name" "Sharjah", "types" ["administrative_area_level_1" "political"]} {"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}], "formatted_address" "Al Dhaid - Sharjah - United Arab Emirates", "geometry" {"bounds" #object[Object ((25.1771597, 55.8154163), (25.3918839, 56.0160042))], "location" #object[Object (25.2881811, 55.9145504)], "location_type" "APPROXIMATE", "viewport" #object[Object ((25.1771597, 55.8154163), (25.3918839, 56.0160042))]}, "place_id" "ChIJow1x3H6-9T4RbXxz_9o_cPw", "types" ["locality" "political"]} {"address_components" [{"long_name" "Sharjah", "short_name" "Sharjah", "types" ["administrative_area_level_1" "political"]} {"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}], "formatted_address" "Sharjah - United Arab Emirates", "geometry" {"bounds" #object[Object ((24.7572593, 55.3490674), (25.6259158, 56.38157039999999))], "location" #object[Object (25.0753974, 55.7578403)], "location_type" "APPROXIMATE", "viewport" #object[Object ((24.7572593, 55.3490674), (25.6259158, 56.38157039999999))]}, "place_id" "ChIJ0Zp9hY5ZXz4RZlq4HHZvx2g", "types" ["administrative_area_level_1" "political"]} {"address_components" [{"long_name" "United Arab Emirates", "short_name" "AE", "types" ["country" "political"]}], "formatted_address" "United Arab Emirates", "geometry" {"bounds" #object[Object ((22.6315138, 51.4576504), (26.0765, 56.4395001))], "location" #object[Object (23.424076, 53.847818)], "location_type" "APPROXIMATE", "viewport" #object[Object ((22.6315138, 51.4576504), (26.0765, 56.4395001))]}, "place_id" "ChIJvRKrsd9IXj4RpwoIwFYv0zM", "types" ["country" "political"]}]
           ;; }

           ;; (get  "location")
           ;; (js-keys ahe)


           (js/map.addListener "click"
                               (fn [e]
                                 (js/marker.setPosition ^js (.-latLng e))))
           (js/marker.addListener "position_changed"
                                  (fn [_]
                                    (let [pos (js/marker.getPosition)
                                          lat (.lat pos)
                                          lon (.lng pos)]
                                      (.then (.geocode geocoder (clj->js {:location pos}))
                                             (fn [ret]
                                               (on-pos-change {:geocode ret
                                                               :lat lat
                                                               :lon lon})))
                                      )))))
       :reagent-render
       (fn []
         [:div#map
          {:style {:width "100%"
                   :height "300px"}
           :ref ref}])})))

(defn gps-location [{:keys [default-coords on-pos-change]}]
  (let [[lon lat] (or default-coords [55.132 25.069])
        *map (r/atom nil)
        *marker (r/atom nil)
        *jump (r/atom false)
        set-pan (fn [{:keys [lat lng] :as loc}]
                  (reset! *jump false)
                  ^js (.setPosition @*marker (clj->js loc))
                  ^js (.panTo @*map (clj->js loc)))
        on-pos-change (debounce on-pos-change 150)]
    (fn []
      [:div.gmaps-component
       [g-map {:*map *map
               :*marker *marker
               :on-pos-change on-pos-change
               :coords {:lat lat
                        :lng lon}}]
       [:button.jump.btn.primary.pill
        {:on-click #(do
                      (reset! *jump true)
                      (get-gps-pos set-pan))
         :type "button"}
        [:i.fa-solid.fa-location-dot]
        (if @*jump
          (tr :forms.request.gps/locating)
          (tr :forms.request.gps/jump))]])))

(defn accordion [header content]
  (let [*open? (r/atom false)]
    (fn []
      [:div.accordion
       [:div.click-wrap
        {:on-click #(swap! *open? not)}
        [header @*open?]]
       (when @*open?
         [content])])))

(defn services [{:keys [init-data on-save]}]
  (let [form-args
        {:schema validation/request-filter
         :on-submit {:valid (fn [{:keys [new-data all-data]}]
                              ;; (dispatch [:set-modal nil])
                              (println [:all all-data :new new-data])
                              (on-save all-data)
                              )
                     :invalid (fn [error]
                                (println "Submit error " error))}
         :init-data init-data}
        {:keys [check radio *data *validated-data form-params input select set-val get-val] :as form-args}
        (form/make-form form-args)

        make-models @(subscribe [:makes-models])

        makes (->> (keys make-models)
                   (mapv #(hash-map
                           :img (format "/static/img/car-makes/%s.png" (str/replace % " " "_"))
                           :value %))
                   (sort-by :title))
        years (mapv #(hash-map :title % :value %) (reverse (range 1940 2025)))
        get-models (fn [make]
                     (mapv #(hash-map :value %)
                           (get make-models make)))
        *make (ra/reaction (get-val [:make]))
        *tags (subscribe [:tags])
        *selected (r/atom {:makes {}
                           :year {:min nil
                                  :max nil}})
        *current-make (r/atom nil)
        make-toggle-fn (fn [make val]
                         (let [path [:makes make]]
                           (if (get-val path)
                             (do
                               (if (= @*current-make make)
                                 (do
                                   (reset! *current-make nil)
                                   (set-val :makes #(dissoc % make)))
                                 (reset! *current-make make)))
                             (do
                               (reset! *current-make make)
                               (set-val path #{})))))
        model-toggle-fn (fn [make model]
                          (let [path [:makes make]]
                            (if ((get-val path) model)
                              (set-val path #(disj % model))
                              (set-val path #(conj % model)))))
        *get-models-fn (fn [value] (ra/reaction (get-val [:makes value])))]
    (fn []
      [:form
       form-params
       [:div#service-filters
        [:div.added-tags]
        [:div.grid-wrap
         [:div.mid.scroll-section
          [:section
           [:h3.title "Business Type"]
           [check
            (mapv (fn [[[val title]]]
                    {:title title
                     :value val})
                  (map vec constants/service-types))
            {:class "horizontal small variant-button"}
            [:type]]]
          [:section
           [:h3.title "Categories"]
           [check
            (mapv (fn [{id :db/id
                        title :tag/title}]
                    {:title title
                     :value id})
                  @*tags)
            {:class "horizontal small variant-button"}
            [:tag]]]

          [:section
           [accordion
            (fn [open?]
              [:h3.title "Year "
               (if open?
                 [:i.fa-regular.fa-chevron-up]
                 [:i.fa-regular.fa-chevron-down])])

            (fn []
              [:div.year-min-max
               [select
                {:label "Year Min"
                 :placeholder "Select Year"
                 :data years}
                [:year :min]]

               [select
                {:label "Year Max"
                 :placeholder "Select Year"
                 :data years}
                [:year :max]]])]]

          [:section.makes-wrap
           [accordion
            (fn [open?]
              [:h3.title "Makes "
               (if open?
                 [:i.fa-regular.fa-chevron-up]
                 [:i.fa-regular.fa-chevron-down])])
            (fn []
              [:div
               (into [:div.makes]
                     (map (fn [{:keys [value img]}]
                            (let [models @(*get-models-fn value) #_(get-val [:makes value])
                                  c (count models)]
                              [:button.make.reset-btn
                               {:on-click #(make-toggle-fn value #{})
                                :type "button"
                                :class
                                (str (when models "active")
                                     (when (= value @*current-make) " current"))}
                               [:img {:src img}]
                               [:div.count
                                (when models
                                  (if (> c 0)
                                    (count models)
                                    "All"))]
                               [:div.title value]]))
                          (sort-by :value makes)))
               (when @*current-make
                 [:div.models-wrap
                  [:h3.title (format "%s %s " @*current-make "Models")]
                  [:div
                   (if-let [models (seq (get-models @*current-make))]
                     (into [:div.models]
                           (map (fn [{:keys [value]}]
                                  (let [active? ((get-val [:makes @*current-make]) value)]
                                    [:button.model.reset-btn
                                     {:on-click #(model-toggle-fn @*current-make value)
                                      :type "button"
                                      :class (when active? "active")}
                                     [:div.title value]]))
                                models))
                     [:div "Select a make"])]])])]]]
         [:div.bottom
          [:button.btn.primary
           {:type "submit"}
           "Save"]]]]])))

(defn services-modal [{:keys [init-data on-save] :as args}]
  [:div.filters-modal.wrap
   [:h1 "Services"]
   [services args]])

(defn service-filter [{:keys [idx data *filters] :as argz}]
  (let [{:keys [makes year type tag]} data
        {:keys [min max]} year

        ;; tag is a set so this works
        tags (when tag (filter #(tag (:db/id %)) @(subscribe [:tags])))


        edit-fn (fn [data]
                  (dispatch [:set-modal nil])
                  (swap! *filters update idx #(merge % data)))

        remove-fn (fn []
                    (swap! *filters #(data-utils/vec-remove % idx)))
        filters (-> []
                    (cond->
                        type (conj
                              [:div
                               [:div.title "Type"]
                               [:div.value
                                (str/join ", " (map #((into {} constants/service-types) %) type))]])

                        tags (conj
                              [:div
                               [:div.title "Categories"]
                               [:span.value
                                (str/join ", " (map :tag/title tags))
                                ]])
                        (and min max)
                        (conj
                         [:div
                          [:div.title "Years"]
                          [:div.value [:span.min min] " - " [:span.max max]]])
                        (and (not max) min)
                        (conj
                         [:div
                          [:div.title "Year Min"]
                          [:div.value min]])
                        (and (not min) max)
                        (conj
                         [:div
                          [:div.title "Year Max"]
                          [:div.value max]])
                        makes (conj
                               [:div
                                [:div.title "Makes"]
                                [:div.value (str/join ", " (map identity (sort (keys makes))))]])))]
    [:div.filter-tag
     (conj (into [:div.filters ""]
                 (map identity filters)))
     (when *filters
       [:div.actions
        [:button.btn.primary.edit
         {:type "button"
          :on-click
          (fn []
            (dispatch [:set-modal
                       {:renderer
                        (fn [] [services-modal {:init-data data
                                                :on-save edit-fn}])}]))}
         [:i.fa-solid.fa-pen-to-square]
         "Edit"]
        #_[:button.btn.remove
           {:type "button"
            :on-click remove-fn
            #_(fn [] (dispatch [:update-data :feed-filters #(data-utils/vec-remove % idx)]))}
           [:i.fa-solid.fa-trash]
           "Remove"]])]))

(defn loading-screen []
  [:div.loading-screen
   [:div.logo svg/logo]
   [:div.dots-loader [:div.dot] [:div.dot] [:div.dot] [:div.dot]]
   [:h2 (tr :general.loading)]])

(defn confirm-action [title action interval]
  (let [*progress (r/atom 0)
        *interval (atom nil)
        interval-speed 20
        steps (/ interval interval-speed)
        clear-interval
        #(when @*interval
           (js/clearInterval @*interval)
           (reset! *interval nil))
        *fired (r/atom false)]
    (fn []
      (let [percent (js/Math.round (* 100 (/ @*progress steps)))
            held? (when @*interval true)

            start-fn (fn []
                       (clear-interval)
                       (when-not @*fired
                         (reset! *interval
                                 (js/setInterval (fn []
                                                   (if (>= @*progress steps)
                                                     (do
                                                       (reset! *fired true)
                                                       (action)
                                                       (clear-interval))
                                                     (swap! *progress inc)))
                                                 interval-speed))))
            end-fn #(do
                      (clear-interval)
                      (when-not @*fired
                        (reset! *progress 0)))]
        [:button.confirm-action.no-select
         {:disabled @*fired
          :class (str/join " " (remove nil? [(when held? "held")
                                             (when @*fired "fired")]))
          :on-context-menu #(.preventDefault %)
          :on-mouse-down start-fn
          :on-touch-start start-fn
          :on-mouse-up end-fn
          :on-touch-end end-fn}
         [:span.title title]
         (when (and
                (< percent 100)
                (> percent 1))
           [:div.hold-to-confirm
            [:span.progress
             [:span.fill
              {:style {:width (str percent "%")}}]
             [:span.helper
              (tr :general.hold-to-confirm)]]])]))))

(defn role-modal []
  (let [?roles @(subscribe [:business-roles])
        current-id @(subscribe [:current-owner-id])
        user @(subscribe [:user])
        unread @(subscribe [:user-unread-by-roles])

        role-itm (fn [{:keys [handle email id unread]}]
                   (let [current? (= id current-id)]
                     [:div.role
                      (if current?
                        {:class "current"}
                        {:on-click #(dispatch [:swap-current-owner id])})
                      [:div.personal
                       [:div.name handle]
                       [:div.email email]]
                      (if current?
                        [:div.sym
                         [:span.txt "Current"]
                         [:i.fa-regular.fa-check]]
                        [:div.sym
                         [:i.fa-regular.fa-chevron-right]])
                      (if (> unread 0)
                        [:span.unread.has
                         "Unread: " [:span.val unread]]
                        [:span.unread
                         "Unread: 0"])]))]
    [:div#role-selector
     [header (tr :page.profile.role.select)]
     [:div.main-content
      [:h4 (tr :page.profile.role.personal.title)]
      [:p.sub (tr :page.profile.role.personal.description)]
      [:div.role-wrap
       (let [{id :db/id :user/keys [name handle email]} user
             unread (get unread id)]
         [role-itm {:id id
                    :unread unread
                    :handle handle
                    :email email}])]
      [:h4 (tr :page.profile.role.business.title)]
      [:p.sub (tr :page.profile.role.business.description)]
      (into [:div.business-roles.role-wrap]
            (map (fn [itm]
                   (let [{id :db/id
                          biz-name :business/name
                          email :business/email} itm
                         unread (get unread id)
                         email (or email "Email not set")]
                     [role-itm {:id id
                                :unread unread
                                :handle biz-name
                                :email email}]))
                 (map second ?roles)))]]))

(defn install-motorsaif []
  (when (and
         (not utils/is-desktop?)
         (not utils/is-pwa?))
    [:div.install-btn.tac
     [:div.title (tr :install-pwa.title)]
     [:a.btn.primary.install-button
      {:href (routes/path-for :pwa)}
      [:img.app-icon {:src "/static/img/msappicon.png"}]
      [:div.txt (tr :install-pwa.button)]]]))


(defn map-image
  [coords]
  (let [[lon lat] coords]
    [:img.gmap {:src
                (format "https://maps.googleapis.com/maps/api/staticmap?center=%s&zoom=12&size=600x600&key=%s&markers=%s"
                        (format "%s,%s" lat lon)
                        js/mapsKey
                        (format "%s,%s" lat lon))}]))

(defn lang-selector []
  (let [lang @(subscribe [:locale])]
    [:section#lang-selector
     [:button.btn.link
      {:on-click #(dispatch [:set-locale :en])
       :type "button"
       :class (when (= lang :en) "active")}
      "English"]
     [:button.btn.link
      {:on-click #(dispatch [:set-locale :ar])
       :type "button"
       :class (when (= lang :ar) "active")}
      (tr :general.arabee)]
     [:button.btn.link
      {:on-click #(dispatch [:set-locale :ur])
       :type "button"
       :class (when (= lang :ur) "active")}
      (tr :general.urdu)]]))

(defn tabs-section [{:keys [tabs active-tab on-tab-click class]}]
  [:div.tabs-wrapper {:class class}
   (into [:div.tabs-section]
         (map (fn [{:keys [key content]}]
                [:button.btn.tab
                 {:class (when (= active-tab key) "active")
                  :on-click #(on-tab-click key)}
                 content])
              tabs))])

(def google-client-id (inline-env :oauth :google :client-id))
(def redirect-uri (inline-env :oauth :google :redirect-uri))
(def scopes
  "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile")

(defn google-auth-url []
  (str "https://accounts.google.com/o/oauth2/v2/auth"
       "?client_id=" google-client-id
       "&redirect_uri=" (js/encodeURIComponent redirect-uri)
       "&response_type=code"
       "&scope=" (js/encodeURIComponent scopes)
       "&access_type=offline"
       "&prompt=consent"))

(defn google-button [type]
  [:button.google-btn
   {:type "button"
    :on-click #(set! (.-location js/window) (google-auth-url))}
   ;; [:i.fa-brands.fa-google]
   [:div.google-icon]
   (condp = type
     :sign-up "Sign up with Google"
     :sign-in "Sign in with Google")])
